export default __webpack_public_path__ + "static/BoardWeb_2022_Takahashi_Mark-d65bb79ad612353d4a52de9526af3d33.jpg";